export default __webpack_public_path__ + "static/media/back.3e1d7346.png";